/* CreateEditExclusionRenderer.js */

"use strict";
const _ = require("lodash");
const uiCore = require("@gluenetworks/steve_ui_core");
const TextControl = uiCore.Control.Textfield.InputText;
const ButtonControl = uiCore.Control.Action.Button;
const ComboBoxControl = uiCore.Control.OptionSelection.Single.ComboBox;
const RadioControl = uiCore.Control.OptionSelection.Single.InputRadio;
const escapeHtml = require("@gluenetworks/dom_utilities").escapeHtml;

// const CheckboxControl = uiCore.Control.Boolean.InputCheckbox;
// const TextAreaControl = uiCore.Control.Textfield.Textarea;
const ipv4SubnetOptions = Array.from(Array(25)).map((e, i) => {
    return {
        label: i + 8,
        value: i + 8,
    };
});

const ipv6SubnetOptions = Array.from(Array(97)).map((e, i) => {
    return {
        label: i + 32,
        value: i + 32,
    };
});

const ipv4Default = 24;
const ipv6Default = 120;

class CreateEditExclusionRenderer {
    constructor(model) {
        /**
         * @type {CreateEditExclusionRenderer}
         */
        this._model = model;
        this._rootElem = this._createRootElement();

        this._ipBlockV4Val = undefined;
        this._ipBlockV6Val = undefined;

        this._ipVersionInput = new RadioControl({
            darkTheme: true,
            horizontal: true,
            options: [
                {
                    label: "IPv4",
                    tooltip: "Select to use IPv4 format",
                    value: false,
                },
                {
                    label: "IPv6",
                    tooltip: "Select to use IPv6 format",
                    value: true,
                },
            ],
            value: false,
        });

        this._ipVersionInputBlock = new RadioControl({
            darkTheme: true,
            horizontal: true,
            options: [
                {
                    label: "IPv4",
                    tooltip: "Select to use IPv4 format",
                    value: false,
                },
                {
                    label: "IPv6",
                    tooltip: "Select to use IPv6 format",
                    value: true,
                },
            ],
            value: false,
        });

        this._ipVersionInputRange = new RadioControl({
            darkTheme: true,
            horizontal: true,
            options: [
                {
                    label: "IPv4",
                    tooltip: "Select to use IPv4 format",
                    value: false,
                },
                {
                    label: "IPv6",
                    tooltip: "Select to use IPv6 format",
                    value: true,
                },
            ],
            value: false,
        });

        this._descriptionInput = new TextControl({
            darkTheme: true,
            label: "Description",
            labelShown: true,
        });

        this._typeDropDown = new ComboBoxControl({
            showFilter: false,
            adjustWidth: true,
            darkTheme: true,
            label: "Exclusion Type",
            labelShown: true,
        });
        this._deviceTypeDropDown = new ComboBoxControl({
            showFilter: false,
            adjustWidth: true,
            darkTheme: true,
            label: "Device Type",
            labelShown: true,
        });
        this._hostNameValue = new TextControl({
            darkTheme: true,
            readOnly: false,
            label: "Hostname",
            labelShown: true,
        });

        this._ipAddress = new TextControl({
            darkTheme: true,
            readOnly: false,
            label: "IP Address",
            labelShown: true,
        });

        this._subnetIpAddress = new TextControl({
            darkTheme: true,
            readOnly: false,
            label: "IP Address",
            labelShown: true,
        });

        this._ipSubnet = new ComboBoxControl({
            darkTheme: true,
            readOnly: false,
            showFilter: false,
            label: "Subnet",
            labelShown: true,
            options: ipv4SubnetOptions,
            value: ipv4Default,
        });

        this._sIpAddress = new TextControl({
            darkTheme: true,
            readOnly: false,
            label: "Start IP Address",
            labelShown: true,
        });

        this._eIpAddress = new TextControl({
            darkTheme: true,
            readOnly: false,
            label: "End IP Address",
            labelShown: true,
        });

        this._serial = new TextControl({
            darkTheme: true,
            readOnly: false,
            label: "Serial Number",
            labelShown: true,
        });

        this._errMsg = document.createElement("error-elem");
        this._saveButton = new ButtonControl({
            label: "Save",
            darkTheme: true,
            disabled: false,
            active: true,
        });
        this._cancelButton = new ButtonControl({id: "cancel", label: "Cancel", disabled: false});
        this._registerListeners();
        this.render();
    }
    get rootElement() {
        return this.getRootElement();
    }
    get model() {
        return this.getModel();
    }
    /*******************************************/
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/
    render() {
        if (this._renderProm === null) {
            return Promise.resolve();
        }
        this._renderProm = this._renderProm || this._render();
        return this._renderProm;
    }
    shutdown() {
        if (this._shutdownProm === null) {
            return Promise.resolve();
        }
        this._shutdownProm = this._shutdownProm || this._shutdown();
        return this._shutdownProm;
    }
    getRootElement() {
        return this._rootElem;
    }
    getModel() {
        return this._model;
    }
    /********************************************/
    /* END PUBLIC COMPONENT RENDERER METHODS    */
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/
    _registerListeners() {
        this._saveButton.addListener(
            "UserClick",
            (this._saveandclosePopUp = this._saveandclosePopUp.bind(this))
        );
        this._cancelButton.addListener(
            "UserClick",
            (this._closePopUp = this._closePopUp.bind(this))
        );
        this._typeDropDown.on("UserValue", (this._exTypeChange = this._exTypeChange.bind(this)));

        this._ipVersionInputBlock.on(
            "UserValue",
            (this._ipVerBlockChange = this._ipVerBlockChange.bind(this))
        );
        // this._testButton.addListener("UserClick", (this._testClick = this._testClick.bind(this)));
        // this._name.on("UserValue", (this._updateEntity = this._updateEntity.bind(this)));
        // this._findString.on("UserValue", (this._updateEntity = this._updateEntity.bind(this)));
        // this._redactionString.on("UserValue", (this._updateEntity = this._updateEntity.bind(this)));

        // this._testInputString.on(
        //     "UserValue",
        //     (this._testInputChange = this._testInputChange.bind(this))
        // );

        // this._caseInsensitiveCheckbox.on(
        //     "UserValue",
        //     (this._updateEntity = this._updateEntity.bind(this))
        // );
        // this._multilineCheckbox.on(
        //     "UserValue",
        //     (this._updateEntity = this._updateEntity.bind(this))
        // );
        // this._globalCheckbox.on("UserValue", (this._updateEntity = this._updateEntity.bind(this)));
        // this._model.on("Error", (this._onError = this._onError.bind(this)));
    }
    _unregisterListeners() {
        this._saveButton.removeListener("UserClick", this._saveandclosePopUp);
        this._cancelButton.removeListener("UserClick", this._closePopUp);
        this._typeDropDown.removeListener("UserValue", this._exTypeChange);
        this._ipVersionInputBlock.removeListener("UserValue", this._ipVerBlockChange);
        // this._findString.removeListener("UserValue", this._updateEntity);
        // this._redactionString.removeListener("UserValue", this._updateEntity);
        // this._testButton.removeListener("UserClick", this._testClick);
        // this._name.removeListener("UserValue", this._updateEntity);
        // this._model.removeListener("Error", this._onError);
        // this._testInputString.removeListener("UserValue", this._testInputChange);
    }
    _render() {
        return this._model._whenModelIsReady().then(() => {
            this._rootElem.innerHTML = "";
            const root = document.createDocumentFragment();
            const title = document.createElement("h2");
            title.innerText = !_.isEmpty(this._model._item) ? "Edit Exclusion" : "Add Exclusion";
            root.appendChild(title);
            root.appendChild(this._createSection("Exclusion Type", this._typeDropDown));
            // root.appendChild(this._typeDropDown.renderer.rootElement);
            this._typeDropDown.setOptions(this._model._typesDropDownOptions);
            const typeValue = this._model._item.exType || "deviceType";
            this._typeDropDown.setValue(typeValue);

            this._deviceTypeDropDown.setOptions(this._model._deviceTypeOptions);
            this._deviceTypeDropDown.setValue(_.get(this._model._deviceTypeOptions, "0.value"));

            const exclusionsContainer = document.createElement("exclusion-form-container");
            root.appendChild(exclusionsContainer);

            this._createForm(exclusionsContainer, typeValue);
            setTimeout(() => this._setFormValues(typeValue, true), 10);
            // root.appendChild(this._descriptionInput.renderer.rootElement);
            root.appendChild(this._createSection("Description", this._descriptionInput, "desc"));
            this._descriptionInput.setValue(_.get(this._model._item, "description", ""));
            root.appendChild(this._errMsg);
            root.appendChild(this._createActionsContainer());
            return new Promise((resolve /*,reject*/) => {
                this._rootElem.appendChild(root);
                // this._enableDisableSaveButton();

                // this._name.focus();

                resolve();
            });
        });
    }
    _createForm(elem, typeValue) {
        // const type = this._model._item.exType || "deviceType";
        const _form = document.createDocumentFragment();

        _form.appendChild(
            this._createBlockSection(this._createSection("Device Type", this._deviceTypeDropDown), {
                className: "deviceType value-div" + (typeValue === "deviceType" ? "" : " hidden"),
            })
        );

        _form.appendChild(
            this._createBlockSection(this._createSection("Hostname", this._hostNameValue), {
                className: "hostName value-div" + (typeValue === "hostName" ? "" : " hidden"),
            })
        );

        const _ipAddSection = document.createDocumentFragment();
        _ipAddSection.appendChild(this._createSection("IP Version", this._ipVersionInput));
        _ipAddSection.appendChild(this._createSection("IP Address", this._ipAddress));

        _form.appendChild(
            this._createBlockSection(_ipAddSection, {
                className: "ipAddress value-div" + (typeValue === "ipAddress" ? "" : " hidden"),
            })
        );

        const _subnetSection = document.createDocumentFragment();
        _subnetSection.appendChild(this._createSection("IP Version", this._ipVersionInputBlock));
        _subnetSection.appendChild(this._createSection("IP Address", this._subnetIpAddress));
        _subnetSection.appendChild(this._createSection("Subnet", this._ipSubnet));
        _form.appendChild(
            this._createBlockSection(_subnetSection, {
                className: "ipBlock value-div" + (typeValue === "ipBlock" ? "" : " hidden"),
            })
        );

        const _ipRangeSection = document.createDocumentFragment();
        _ipRangeSection.appendChild(this._createSection("IP Version", this._ipVersionInputRange));
        _ipRangeSection.appendChild(this._createSection("Start IP Address", this._sIpAddress));
        _ipRangeSection.appendChild(this._createSection("End IP Address", this._eIpAddress));
        _form.appendChild(
            this._createBlockSection(_ipRangeSection, {
                className: "ipRange value-div" + (typeValue === "ipRange" ? "" : " hidden"),
            })
        );

        _form.appendChild(
            this._createBlockSection(this._createSection("Serial Number", this._serial), {
                className:
                    "serialNumber value-div" + (typeValue === "serialNumber" ? "" : " hidden"),
            })
        );

        elem.appendChild(_form);
    }
    _setFormValues(exType, initial = false) {
        let type = this._model._item.exType;
        if (!type && !exType) {
            console.log("Something seems to be wrong, no exclusion type selection!");
        }
        if (!exType) {
            exType = type;
        }
        if (!initial) {
            this._rootElem.querySelectorAll(".value-div").forEach((elem) => {
                elem.classList.add("hidden");
            });
            const typeFormEl = this._rootElem.querySelector("." + exType);
            if (typeFormEl) {
                this._rootElem.querySelector("." + exType).classList.remove("hidden");
            }
        }

        if (exType && exType !== type) {
            switch (exType) {
                case "ipAddress":
                    this._ipVersionInput.setValue(false);
                    break;
                case "ipBlock":
                    this._ipVersionInputBlock.setValue(false);
                    break;
                case "ipRange":
                    this._ipVersionInputRange.setValue(false);
                    break;
            }
            return;
        }
        let value = this._model._item.value;
        let values, validatedIp;
        switch (exType) {
            case "deviceType":
                this._deviceTypeDropDown.setValue(
                    value || _.get(this._model._deviceTypeOptions, "0.value")
                );
                break;
            case "hostName":
                this._hostNameValue.setValue(value);
                break;
            case "ipAddress":
                this._ipAddress.setValue(value);
                validatedIp = this._validateIp(value);
                if (validatedIp.valid) {
                    if (validatedIp.ipType === 4) {
                        this._ipVersionInput.setValue(false);
                    } else {
                        this._ipVersionInput.setValue(true);
                    }
                }
                break;
            case "ipBlock":
                values = value.split("/");
                this._subnetIpAddress.setValue(values[0]);
                validatedIp = this._validateIp(values[0]);
                if (validatedIp.ipType === 4) {
                    if (validatedIp.valid) {
                        this._ipVersionInputBlock.setValue(false);
                    }
                    this._ipSubnet.setOptions(ipv4SubnetOptions);
                    this._ipSubnet.setValue(ipv4Default);
                    this._ipBlockV4Val = parseInt(values[1], 10);
                } else {
                    if (validatedIp.valid) {
                        this._ipVersionInputBlock.setValue(true);
                    }
                    this._ipSubnet.setOptions(ipv6SubnetOptions);
                    this._ipSubnet.setValue(ipv6Default);
                    this._ipBlockV6Val = parseInt(values[1], 10);
                }

                this._ipSubnet.setValue(parseInt(values[1], 10));
                break;
            case "ipRange":
                this._sIpAddress.setValue(value.start);
                this._eIpAddress.setValue(value.end);
                validatedIp = this._validateIp(value.start);
                if (validatedIp.valid) {
                    if (validatedIp.ipType === 4) {
                        this._ipVersionInputRange.setValue(false);
                    } else {
                        this._ipVersionInputRange.setValue(true);
                    }
                }
                break;
            case "serialNumber":
                this._serial.setValue(value);
        }
    }

    _validateForm() {
        const formValues = this._getFormValues();
        const type = formValues.type;
        const value = formValues.value;
        let isValid = false;
        let ipType = false;
        let msg = "";
        try {
            switch (type) {
                case "deviceType":
                    if (value) {
                        isValid = true;
                    }
                    if (!isValid) {
                        msg = "Please select a device type.";
                    }
                    break;
                case "hostName":
                    isValid = this._validateHostName(value);
                    if (!isValid) {
                        msg = "Please enter a valid hostname.";
                    }
                    break;
                case "ipAddress":
                    ipType = this._ipVersionInput.getValue();
                    isValid = this._validateIp(value, ipType).valid;
                    if (!isValid) {
                        msg = "Please enter a valid IP address.";
                    }
                    break;
                case "ipBlock":
                    ipType = this._ipVersionInputBlock.getValue();
                    isValid = this._validateIp(value.split("/")[0], ipType).valid;
                    if (!isValid) {
                        msg = "Please enter a valid IP address.";
                    }
                    break;
                case "ipRange":
                    ipType = this._ipVersionInputRange.getValue();
                    isValid = this._validateIpRange(value.start, value.end, ipType);
                    if (!isValid) {
                        msg = "Please enter valid IP addresses.";
                    }
                    break;
                case "serialNumber":
                    isValid = !!value;
                    if (!isValid) {
                        msg = "Please enter a valid serial.";
                    }
                    break;
            }
        } catch (err) {
            console.log(err);
            isValid = false;
            msg = "Please check the values entered.";
        }
        return {
            formValues,
            isValid,
            msg,
        };
    }

    _validateIpRange(val1, val2, type) {
        const sValid = this._validateIp(val1, type);
        const eValid = this._validateIp(val2, type);
        if (sValid.ipType !== eValid.ipType) {
            return false;
        }
        if (sValid.valid && eValid.valid) {
            return true;
        }
        return false;
    }

    _validateIp(val, type) {
        let ipType = 4;
        const v4expression =
            /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
        const v6expression = /^([0-9A-Fa-f]{1,4}::?){1,7}[0-9A-Fa-f]{1,4}$/;
        if (_.isUndefined(type)) {
            if (v4expression.test(val)) {
                ipType = 4;
                return {
                    ipType,
                    valid: true,
                };
            }
            if (v6expression.test(val)) {
                ipType = 6;
                return {
                    ipType,
                    valid: true,
                };
            }
            return {
                ipType,
                valid: false,
            };
        }
        if (type) {
            ipType = 6;
        } else {
            ipType = 4;
        }

        if (ipType === 4) {
            if (v4expression.test(val)) {
                return {
                    ipType,
                    valid: true,
                };
            }
        }
        if (ipType === 6) {
            if (v6expression.test(val)) {
                return {
                    ipType,
                    valid: true,
                };
            }
        }

        return {
            ipType,
            valid: false,
        };
    }

    _validateHostName(val) {
        let valid = false;
        if (!val) {
            return valid;
        }
        try {
            new RegExp(val);
            valid = true;
        } catch (err) {
            valid = false;
        }
        return valid;
    }

    _getFormValues() {
        let type = this._typeDropDown.getValue();
        if (!type) {
            console.log("Something seems to be wrong, no exclusion type selection!");
        }
        let value;
        switch (type) {
            case "deviceType":
                value = this._deviceTypeDropDown.getValue();
                break;
            case "hostName":
                value = escapeHtml(this._hostNameValue.getValue());
                break;
            case "ipAddress":
                value = this._ipAddress.getValue();
                break;
            case "ipBlock":
                value = this._subnetIpAddress.getValue() + "/" + this._ipSubnet.getValue();
                break;
            case "ipRange":
                value = {
                    start: this._sIpAddress.getValue(),
                    end: this._eIpAddress.getValue(),
                };
                break;
            case "serialNumber":
                value = escapeHtml(this._serial.getValue());
                break;
        }
        return {
            type,
            value,
        };
    }
    _shutdown() {
        this._unregisterListeners();
        this._rootElem.remove();
        this._rootElem = null;
        return Promise.all([this._saveButton.shutdown(), this._cancelButton.shutdown()])
            .then(() => {
                this._model = null;
                this._shutdownProm = null;
                this._renderProm = null;
            })
            .catch((error) => {
                console.log(`${this.constructor.name}: error in shutdown`);
                console.error(error);
            });
    }
    /********************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS   */
    /* START PRIVATE RENDERER METHODS           */
    /********************************************/
    _createRootElement() {
        const rootElement = document.createElement("div");
        rootElement.classList.add("create-edit-exclusion", "modal_feedback_container");
        rootElement.component = this._model;
        return rootElement;
    }
    _createSection(name, Compnent, className) {
        const section = document.createElement("section");
        const label = document.createElement("label");
        section.className = "key-section";
        if (className) {
            section.classList.add(className);
        }
        label.innerText = name;
        Compnent.setAttribute("rows", "6");
        section.appendChild(label);
        section.appendChild(Compnent.renderer.rootElement);
        return section;
    }
    _createBlockSection(content, options = {}) {
        const section = document.createElement("section");
        section.className = options.className || "";
        section.classList.toggle("bordered", !!options.bordered);
        if (options.title) {
            const title = document.createElement("h2");
            title.innerText = options.title;
            section.appendChild(title);
        }
        section.appendChild(content);
        return section;
    }
    _createActionsContainer() {
        const container = document.createElement("section");
        container.className = "actions-container";
        container.appendChild(this._cancelButton.renderer.rootElement);
        container.appendChild(this._saveButton.renderer.rootElement);
        return container;
    }

    _createTestSection() {
        const testArea = document.createElement("div");
        testArea.classList.add("test-container");
        const testStringLabel = document.createElement("label");
        testStringLabel.innerText = "Original String";
        const redactedStringLabel = document.createElement("label");
        redactedStringLabel.innerText = "Redacted String";
        const origStringArea = document.createElement("div");
        origStringArea.classList.add("text-area");
        const redacStringArea = document.createElement("div");
        redacStringArea.classList.add("text-area");

        origStringArea.appendChild(testStringLabel);
        origStringArea.appendChild(this._testInputString._renderer._rootElem);
        redacStringArea.appendChild(redactedStringLabel);
        redacStringArea.appendChild(this._redactedString._renderer._rootElem);
        testArea.appendChild(origStringArea);
        testArea.appendChild(redacStringArea);
        testArea.appendChild(this._testButton._renderer._rootElem);
        return this._createBlockSection(testArea, {title: "Test Expression", bordered: true});
    }
    /********************************************/
    /* END PRIVATE RENDERER METHODS             */
    /* START HANDLER METHODS                    */
    /********************************************/
    /**/
    _saveandclosePopUp() {
        // return this._model.saveandclosePopUp();
        this._clearError();
        const val = this._validateForm();
        const item = this._model._item;

        if (!val.isValid) {
            return this._onError(val.msg);
        }
        item.value = val.formValues.value;
        item.exType = val.formValues.type;
        item.type = this._model._exclusionTypes[item.exType];
        item.description = this._descriptionInput.getValue();
        item.hasPerm = this._model._hasPerm;
        return this._model.saveandclosePopUp(item);
    }
    _closePopUp() {
        // this._model
        return this._model.closePopUp();
    }

    _exTypeChange(val) {
        this._clearError();
        this._setFormValues(val);
    }

    _ipVerBlockChange(val) {
        if (val) {
            this._ipBlockV4Val = this._ipSubnet.getValue();
            this._ipSubnet.setOptions(ipv6SubnetOptions);
            this._ipSubnet.setValue(this._ipBlockV6Val || ipv6Default);
        } else {
            this._ipBlockV6Val = this._ipSubnet.getValue();
            this._ipSubnet.setOptions(ipv4SubnetOptions);
            this._ipSubnet.setValue(this._ipBlockV4Val || ipv4Default);
        }
    }
    _testClick() {
        const findString = _.trim(this._findString.getValue()),
            redactionString = _.trim(this._redactionString.getValue()),
            originalString = _.trim(this._testInputString.getValue()),
            cI = this._caseInsensitiveCheckbox.getValue() ? "i" : "",
            mL = this._multilineCheckbox.getValue() ? "m" : "",
            gL = this._globalCheckbox.getValue() ? "g" : "",
            regEx = new RegExp(findString, `${cI}${mL}${gL}`);

        const redactedString = originalString.replace(regEx, redactionString);

        this._redactedString.setValue(redactedString);
    }
    _testInputChange() {
        this._redactedString.setValue("");
        if (_.trim(this._testInputString.getValue()) !== "") {
            this._testButton.setDisabled(false);
        } else {
            this._testButton.setDisabled(true);
        }
    }
    _updateEntity() {
        this._redactedString.setValue("");
        this._model._redactionEntityInst.setName(this._name.getValue() || "");
        this._model._redactionEntityInst.setRegex(this._findString.getValue() || "");
        this._model._redactionEntityInst.setRedactionString(this._redactionString.getValue() || "");
        this._model._redactionEntityInst.setIsCaseInsensitive(
            this._caseInsensitiveCheckbox.getValue()
        );
        this._model._redactionEntityInst.setIsMultiline(this._multilineCheckbox.getValue());
        this._model._redactionEntityInst.setIsGlobal(this._globalCheckbox.getValue());
        this._enableDisableSaveButton();
        this._clearError();
    }
    _enableDisableSaveButton() {
        if (!this._formInvalid()) {
            if (!_.isEmpty(this._model._redactionEntityInst._pendingPatches)) {
                this._saveButton.setDisabled(false);
            } else {
                this._saveButton.setDisabled(true);
            }
        } else {
            this._saveButton.setDisabled(true);
        }
    }
    _formInvalid() {
        return _.isEmpty(this._name.getValue()) || _.isEmpty(this._findString.getValue());
    }
    _onError(err) {
        this._errMsg.innerHTML = err;
    }
    _clearError() {
        this._errMsg.innerHTML = "";
    }
    /********************************************/
    /* END HANDLER METHODS                      */
    /* START PRIVATE API METHODS                */
    /********************************************/
    /*******************************************/
    /*  END PRIVATE API METHODS                */
    /* START PUBLIC API METHODS                */
    /********************************************/
    /*******************************************/
    /*  END PUBLIC API METHODS                */
    /*******************************************/
}
module.exports = CreateEditExclusionRenderer;
